// Shared ESM component and layout mapping helpers

// Mapping from Project Page Type -> ESM page layout
export const PROJECT_PAGE_TYPE_TO_LAYOUT = {
  "Project Pre-Qualification": "ProjectPreQualificationPage",
  "Project Qualification Page": "ProjectQualificationPage",
  "Project Active Page": "ProjectActivePage",
  // Splash and Default Qualification Page handled specially by callers
};

// Mapping from PPC type/name to ESM component name.
// Keep in sync with ESM_INTEGRATION.md
